import { useMemo, useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, ModalHeader, FormGroup, Label, Input } from 'src/components/ui';
import { getTestId } from '../../hooks/useTestId';
import { Trans } from '@lingui/react/macro';
import { concatenatePaths, getObject } from '../../util/mapObject';


const PARAMS = ['rejectReasonFieldPath', 'contextPath'];


function RejectionReason({
  contextPath,
  rejectReasonFieldPath,
  formData: rootFormData,
  formContext,
  onConfirm: onClose,
  isOpen,
  testIdBase = 'rejection-reason-modal',
}) {
  const {
    setFormDataValues,
  } = formContext;

  const fieldPath = useMemo(() => concatenatePaths(contextPath, rejectReasonFieldPath), [contextPath, rejectReasonFieldPath]);
  const description = useMemo(() => getObject(rootFormData, concatenatePaths(contextPath, 'description')), [rootFormData, contextPath]);
  const defRejectReason = useMemo(() => getObject(rootFormData, fieldPath), [rootFormData, fieldPath]);

  const [rejectReason, setRejectReason] = useState(defRejectReason);

  function onChange({ target: { value } }) {
    setRejectReason(value);
  }

  function onAccept(e) {
    e.stopPropagation();
    setFormDataValues({ [fieldPath]: rejectReason });
    onClose();
  }

  return (
    <Modal isOpen={isOpen}
      toggle={onClose}
      className="modal-primary"
      size='xl'
      backdrop
    >
      <ModalHeader
        toggle={onClose}
      >
        <Trans>Rejection Reason</Trans>
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="modal_dd"><Trans>Description</Trans></Label>
          <Input type="static" name="text" id="modal_dd" value={description} readOnly {...getTestId(testIdBase, '.', 'description')} />
        </FormGroup>
        <FormGroup>
          <Label for="modal_rr"><Trans>Rejection Reason</Trans></Label>
          <Input type="textarea" name="text" id="modal_rr" value={rejectReason || ''} onChange={onChange} {...getTestId(testIdBase, '.', 'rejection-reason')} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onAccept} color="primary" {...getTestId(testIdBase, '.', 'accept')}>
          <Trans>Accept</Trans>
        </Button>
        <Button onClick={onClose} color="secondary" {...getTestId(testIdBase, '.', 'close')}>
          <Trans>Close</Trans>
        </Button>
      </ModalFooter>
    </Modal>
  );
}

RejectionReason.PARAMS = PARAMS;

export default RejectionReason;
